import { Role } from '../../enums/role.enum';

export class User {
  id!: string;
  startDate!: Date;
  endDate!: Date;
  workingYear!: number;
  details: UserDetails | undefined;
}

export class UserDetails {
  badgeNumber!: string | null;
  email!: string | null;
  firstName!: string | null;
  lastName!: string | null;
  level!: string | null;
  role!: Role | null;
  title!: string | null;
  currentCategorySeniority?: string | undefined;
  currentLevelSeniority?: string | undefined;
  recruitmentDate?: string | undefined;
  publicAdministrationSeniority?: string | undefined;
  enabled!: boolean | null;
}
